import { useFetch } from "@/lib/api";
import { fundColor } from "@/lib/finance";
import { changeClass, num, pct } from "@/lib/format";
import { Skeleton } from "@/components/ui/skeleton";

const ORDER = ["G", "F", "C", "S", "I", "L Income", "L 2030", "L 2040", "L 2050", "L 2060", "L 2070"];

export function FundWatchlist({ compactList = true }) {
  const { data, loading } = useFetch("/prices/latest");
  const rows = (data?.prices || []).filter((p) => !compactList || ORDER.includes(p.fund)).sort((a, b) => ORDER.indexOf(a.fund) - ORDER.indexOf(b.fund));
  if (loading) return <div className="space-y-2">{[...Array(6)].map((_, i) => <Skeleton key={i} className="h-7" />)}</div>;
  if (!rows.length) return <p className="text-sm text-muted-foreground" data-testid="watchlist-empty">No prices yet. They load after the first nightly fetch.</p>;
  return (
    <div data-testid="fund-watchlist">
      <p className="text-xs text-muted-foreground mb-3 font-mono-num">As of {rows[0]?.date}</p>
      <table className="w-full text-sm">
        <thead><tr className="text-xs text-muted-foreground"><th className="text-left font-medium pb-2">Fund</th><th className="text-right font-medium pb-2">Price</th><th className="text-right font-medium pb-2">1D</th></tr></thead>
        <tbody>
          {rows.map((r) => (
            <tr key={r.fund} className="border-t border-border/60" data-testid={`watchlist-row-${r.fund.replace(" ", "-")}`}>
              <td className="py-1.5"><span className="inline-flex items-center gap-2"><span className="h-2 w-2 rounded-full" style={{ background: fundColor(r.fund) }} />{r.fund.length === 1 ? `${r.fund} Fund` : r.fund}</span></td>
              <td className="py-1.5 text-right font-mono-num">${num(r.price)}</td>
              <td className={`py-1.5 text-right font-mono-num ${changeClass(r.change_pct)}`}>{pct(r.change_pct)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
